(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('DashboardController', DashboardController);

  /* ngInject */
  function DashboardController(Flash, bannerService, config, requestDemoService, profileService, sessionService) {
    const vm = this;

    vm.activate = activate;
    vm.banners = [];
    vm.config = config;
    vm.getBanners = getBanners;
    vm.hasProduct = hasProduct;
    vm.sendRequestDemo = sendRequestDemo;
    //vm.user = null;
    vm.profile = {};
    vm.getProfile = getProfile;

    vm.activate();

    function activate() {
      profileService(sessionService.getAuthToken()).get(_response => {});
      getBanners();
      getProfile();
      //vm.user = sessionService.getUser();
    }

    function getBanners() {
      bannerService(sessionService.getAuthToken()).query(response => vm.banners = response);
    }
    function getProfile() {
      profileService(sessionService.getAuthToken()).get(response => {
        vm.profile = response;
      });
    }
    function hasProduct(productName) {
      const productRoles = sessionService.getProductRoles();
      // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
      return productRoles.filter(productRole => productName == productRole.product_name).length > 0;
    }

    function sendRequestDemo(productName) {
      requestDemoService(sessionService.getAuthToken()).save({product: productName}, _response => Flash.create('success', 'Your request for a demo was successfully sent. Thanks!'));
    }
  }
})();
